import { useEffect, useState } from 'react';
import {
  Carousel,
  CarouselItem,
  Spinner
} from 'react-bootstrap';
import axios from 'axios';

import GalleryPage from './GalleryPage';

const SearchResults = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedIndex, setLoadedIndex] = useState(0);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const slideHandler = (eventKey, direction) => {
    if (direction === 'start') {
      setCurrentIndex(prevIndex => prevIndex + 1);
    } else if (direction === 'end') {
      setCurrentIndex(prevIndex => prevIndex - 1);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    setLoadedIndex(0);
    setCurrentIndex(0);
    setFetchedData([]);
  }, [props.searchString])

  useEffect(() => {
    // setIsLoading(true);
    if (currentIndex === loadedIndex && props.clientCountryCode.length) {
      axios.post(process.env.REACT_APP_HOSTNAME + '/api/client/products/search', {
        limit: 10,
        offset: Math.round(9 * loadedIndex),
        searchString: props.searchString,
        countryCode: props.clientCountryCode
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + process.env.REACT_APP_TOKEN
        }
      })
        .then((data) => {
          setFetchedData(prevData => {
            return [...prevData, data?.data?.data?.products ]
          });
          // if no results then we set currentIndex to +1 to be able to triger reload on a new search 
          // if (currentIndex === 0 && data?.data?.data?.products.length < 7) setCurrentIndex(1);
          // always loading +1 page from the current displayed page
          setLoadedIndex(prevIndex => prevIndex + 1);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
  }, [currentIndex, loadedIndex, props.clientCountryCode])

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            width: '100%',
            margin: '1.5px 0',
            aspectRatio: '48/20',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
        ) : fetchedData[0]?.length ? (
        <Carousel
          indicators={false}
          slide={false}
          wrap={false}
          interval={null}
          prevIcon={<>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#f04059" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                      </svg>
                      <div>Back</div>
                    </>}
          nextIcon={<>
                      <div>Next</div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#f04059" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                      </svg>
                    </>}
          onSlid={slideHandler}
        >
          {fetchedData.map((val, i) => {
            return (
              <CarouselItem key={"cards_gallery_page_key_" + i}>
                <GalleryPage
                  data={val}
                  isLoading={isLoading}
                />
              </CarouselItem>
            )
          })}
          {!!fetchedData && fetchedData[fetchedData.length - 1]?.length === 10 && (
            <CarouselItem>
              <div
                style={{
                  width: '100%',
                  margin: '1.5px 0',
                  aspectRatio: '48/20',
                  height: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
              </div>
            </CarouselItem>
          )}
        </Carousel>
        ) : (
          <div
            style={{
              width: '100%',
              padding: '19% 0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <h3>No results found</h3>
          </div>
        )}
    </div>);
}

export default SearchResults;
